<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >
    <FormItem label="当天最大点赞数" prop="day_max_like_count">
        <Input v-model="formValidate.day_max_like_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大评论数" prop="day_max_comment_count">
        <Input v-model="formValidate.day_max_comment_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大关注数" prop="day_max_follower_count">
        <Input v-model="formValidate.day_max_follower_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大私信数" prop="day_max_letter_count">
        <Input v-model="formValidate.day_max_letter_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大搜索关键字" prop="day_max_search_count">
        <Input v-model="formValidate.day_max_search_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="账号类型"  prop="video_classify_id">
        <Select v-model="formValidate.video_classify_id">
          <Option
            v-for="item in shortVideoClassifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>
      
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contacts_list:[],
      shortVideoClassifyIds:[],
      formValidate: {
        day_max_like_count: '',
        day_max_comment_count:'',
        day_max_follower_count:'',
        day_max_letter_count:'',
        day_max_search_count:'',
        video_classify_id:'',
        id: ''
      },
      ruleValidate: {
        day_max_like_count: [
          {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],           
        day_max_comment_count: [
          {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],  day_max_follower_count:[
        {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],day_max_letter_count:[
        {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],day_max_search_count:[
        {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],video_classify_id:[
        {
            required: true,
            message: '分类必须要选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setVideoClassify(shortVideoClassifys){
      var data = new Array()
      for (var i = 0; i < shortVideoClassifys.length; i++) {
        data[i] = { id: shortVideoClassifys[i].id.toString(), name: shortVideoClassifys[i].name }
      }
      this.shortVideoClassifyIds = data
    },

    setEditData (params) {
      this.formValidate.day_max_like_count = params.day_max_like.toString()
      this.formValidate.day_max_comment_count = params.day_max_comment.toString()
      this.formValidate.day_max_follower_count = params.day_max_follower.toString()
      this.formValidate.day_max_letter_count = params.day_max_letter.toString()
      this.formValidate.day_max_search_count = params.day_max_search.toString()
      this.formValidate.video_classify_id = params.video_classify_id.toString()
      this.formValidate.id = params.id
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
